import { render, staticRenderFns } from "./TypeToSelect.vue?vue&type=template&id=5d0baf80&"
import script from "./TypeToSelect.vue?vue&type=script&lang=js&"
export * from "./TypeToSelect.vue?vue&type=script&lang=js&"
import style0 from "./TypeToSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports